// src/functions/flush-cookies.js
import { Cookies } from 'quasar'

const RESET_KEY = 'platform_reset_at'

export function flushCookies() {
  const resetDate = localStorage.getItem(RESET_KEY)

  if (resetDate) {
    return Cookies.getAll()
  }

  const allCookies = Cookies.getAll()
  const keys = Object.keys(allCookies)

  keys.forEach(name => {
    Cookies.remove(name, { path: '/' })
    Cookies.remove(name, { path: '/', domain: window.location.hostname })
  })

  const now = new Date().toISOString()
  localStorage.setItem(RESET_KEY, now)

  return Cookies.getAll()
}
